





































// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
// project
import { getDeepProperty as getDeepObjectProperty } from "@/utils/object";
import { BuildInfo } from "@/info";
import { loadEnvironment, getValue } from "@/env";
import { NavLeft } from "@/components.nav/nav-left";
import { NavTop } from "@/components.nav/nav-top";
import { useUserPrefs } from "@/hooks/useUserPrefs";
// local
import { default as AppModals } from "./AppModals.vue";

export default defineComponent({
	components: {
		NavLeft,
		NavTop,
		AppModals,
	},
	setup(props, context) {
		const ready = ref(false);
		const { menuOpen } = useUserPrefs();

		const hasAuth = computed(() => {
			return context.root.$store.getters.authenticated;
		});

		const showNav = computed(() => {
			let hidden = getDeepObjectProperty(
				context.root.$route,
				"meta.navHidden",
				false,
			);
			if (hidden) {
				return false;
			}
			return context.root.$store.getters.authenticated;
		});
		const init = async () => {
			await loadEnvironment();
			ready.value = true;
		};
		const routeKey = computed(() => {
			const r = context.root.$route;
			if (r.meta && r.meta.viewKey) {
				let s: string = r.meta.viewKey;
				Object.keys(r.params).forEach((pk) => {
					s = s.replaceAll(`$${pk}`, r.params[pk]);
				});
				return s;
			}
			return r.path;
		});
		init();
		console.log(BuildInfo);
		return {
			ready,
			showNav,
			menuOpen,
			routeKey,
			hasAuth,
		};
	},
});
